module.exports = __webpack_public_path__ + "static/img/logout.23a76f0b.png";